import { type ReactNode } from 'react';

type HidableColumnProps = {
  id: string;
  isVisible: (id: string) => boolean;
  children: ReactNode;
};

export const HidableColumn = ({
  id,
  isVisible,
  children,
}: HidableColumnProps) => {
  if (!isVisible(id)) return null;
  return <>{children}</>;
};
